// ============================================================================
// todo-client-mod -- useTodo Hook
//
// 获取单条 Todo 详情。
// 支持 SSR：传入 initialData 则直接使用（不请求）。
// ============================================================================
import { useState, useEffect, useRef } from 'react';
import { getTodoApiClient } from '../todo-api-client.js';
/**
 * 获取单条 Todo 详情
 */
export function useTodo(id, initialData) {
    const [todo, setTodo] = useState(initialData ?? null);
    const [loading, setLoading] = useState(!initialData);
    const [error, setError] = useState(null);
    const isFirstRender = useRef(true);
    const fetchTodo = async () => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            if (initialData)
                return;
        }
        setLoading(true);
        setError(null);
        try {
            const result = await getTodoApiClient().getTodo(id);
            setTodo(result);
        }
        catch (err) {
            const message = err instanceof Error ? err.message : '获取待办事项失败';
            setError(message);
            setTodo(null);
        }
        finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (id) {
            fetchTodo();
        }
    }, [id, initialData]);
    return {
        todo,
        loading,
        error,
        refresh: fetchTodo,
    };
}
//# sourceMappingURL=use-todo.js.map